import { useCallback, useEffect, useRef } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

const RECAPTCHA_READY_RETRY_DELAY_MS = 100
const RECAPTCHA_READY_TIMEOUT_MS = 3000

export const useExecuteRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha()
  const executeRecaptchaRef = useRef(executeRecaptcha)

  useEffect(() => {
    executeRecaptchaRef.current = executeRecaptcha
  }, [executeRecaptcha])

  return useCallback(
    (action: string, fn: (token: string | void) => void) => {
      const startedAt = Date.now()

      const handleExecuteRecaptcha = () => {
        const execute = executeRecaptchaRef.current

        if (!execute) {
          if (Date.now() - startedAt >= RECAPTCHA_READY_TIMEOUT_MS) return fn()

          window.setTimeout(handleExecuteRecaptcha, RECAPTCHA_READY_RETRY_DELAY_MS)
          return
        }

        try {
          execute(action)
            .then((token) => {
              fn(token)
            })
            .catch((err) => {
              console.warn('Failed to executeRecaptcha:', err)
              fn()
            })
        } catch (e) {
          console.warn(e)
          fn()
        }
      }

      handleExecuteRecaptcha()
    },
    [],
  )
}
